// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__1UMST","open":"MenuToggle_open__1VUg8"};